(ns dre.widgets.clinical-studies.views
  (:require
   [applied-science.js-interop :as j]
   [clojure.string :as s]
   [dre.components.icon :refer [fa-icon]]
   [dre.components.inputs :refer [input-number]]
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.components.sankey-diagram :refer [sankey-diagram]]
   [dre.i18n.views :refer [tr]]
   [dre.pages.search.events :as search-events]
   [dre.widgets.clinical-studies.events :as events]
   [dre.components.widget.events :as wevents]
   [re-frame.core :as rf]))

(defn selected-pills-fn [filters]
  (->> filters
       #_(remove events/study-size-pill?)
       (map (fn [and-or-single]
              (if-let [pills (:pill/pills and-or-single)]
                (clj->js (map :pill/label pills))
                (:pill/label and-or-single))))
       clj->js))

(defn sankey-select-fn [d]
  (let [filter (if (and (j/get d :source)
                        (j/get d :target))
                 (let [;; links
                       source (j/get d :source)
                       target (j/get d :target)
                       path [{:type (j/get source :type)
                              :name (j/get source :name)}
                             {:type (j/get target :type)
                              :name (j/get target :name)}]]
                   (events/->category-pills path))
                 (let [;; single node
                       target d
                       node {:type (j/get target :type)
                             :name (j/get target :name)}]
                   (events/->category-pill node)))]
    (rf/dispatch [::search-events/widget-filter-select
                  events/id filter])))

;; Remove "Clinical study"/"RCT" nodes per client request
;; even though some trials don't have phases associated.
;; Also merge "Unknown status" with "Other"
(defn- limit-sankey
  [categories]
  (let [{:keys [nodes links]} (js->clj categories :keywordize-keys true)
        nodes (->> nodes
                   (remove #(#{"ct" "rct" "study/unknown-status"} (:type %)))
                   (cons {:name "Undisclosed"
                          :type "study/other"}))
        links (->> links
                   (remove #(s/starts-with? (:targetType %) "phase/"))
                   (remove #(#{"rct" "study/unknown-status"} (:targetType %)))
                   (map #(cond-> %
                                 (#{"ct" "rct"} (:sourceType %))
                                 (assoc :source "Undisclosed"
                                        :names ["Undisclosed" (:target %)])))
                   (map #(cond-> %
                                 (= "study/unknown-status" (:targetType %))
                                 (assoc :target "Other"
                                        :names [(:source %) "Other"]))))]
    (clj->js {:nodes nodes
              :links links})))

(defn display-sankey
  [id]
  (let [data-sankey @(rf/subscribe [::events/data-sankey])
        data @(rf/subscribe [::events/data-study-size])
        widget-filters @(rf/subscribe [::search-events/widget-filters])
        filters (get widget-filters events/id)
        selected (selected-pills-fn filters)]
    [:<>
     (if (not (seq data))
       [no-result true]
       [sankey-diagram (limit-sankey data-sankey) sankey-select-fn selected])]))

(defn display-study-size
  [id]
  (let [data @(rf/subscribe [::events/data-study-size])]
    [:<>
     (if (not (seq data))
       [no-result true]
       [table-list "clinical-study-table" data {:sort-fn :idx}])]))

(defn display-list
  [id]
  (let [data @(rf/subscribe [::events/data])]
    [:<>
     (if (not (seq data))
       [no-result true]
       [table-list "clinical-study-table" data {:sort? false}])]))

(def ^:private display->component
  {:sankey display-sankey
   :list display-list
   :study-size display-study-size})

(defn widget-content
  [_id _selected-tab]
  (fn [id selected-tab]
    [(display->component selected-tab) id]))

(defn widget-footer
  [id selected-tab]
  (if (= :study-size selected-tab)
    (let [interval @(rf/subscribe [::events/study-size-interval])]
      [:div
       [tr "Interval"]
       [:span ": "]
       [input-number
        {:max 100000000
         :min 1
         :step 100
         :size "small"
         :value interval
         :on-blur (fn [e]
                    (rf/dispatch [::events/set-study-size-interval (js/parseInt (.-value (.-target e)))]))
         :on-press-enter (fn [e]
                    (rf/dispatch [::events/set-study-size-interval (js/parseInt (.-value (.-target e)))]))
         :on-step #(rf/dispatch [::events/set-study-size-interval %])}]])
    nil))

(defn view
  [id title]
  (let [status @(rf/subscribe [::events/status]) 
        loading? (= :loading status)
        default-tab :list
        selected-tab @(rf/subscribe [::wevents/selection id ::display])
        selected-tab (if (not selected-tab)
                       default-tab
                       selected-tab)]
    [widget-base/view id [title-with-filter title id] [widget-content id selected-tab]
     nil
     [widget-footer id selected-tab]
     {:csv-event [::events/export]
      :export-image? true
      :selections
      [{:id ::display
        :type :tabs
        :default-option default-tab
        :options [{:id :sankey :label [fa-icon :diagram-project]}
                  {:id :list :label [fa-icon :list]}
                  {:id :study-size :label [fa-icon :user-group]}]}]}
     {:loading? loading?}]))
